import { ArrowRightOutlined } from "@ant-design/icons";
import { Card, Skeleton, Statistic } from "antd";
import cn from "classnames";
import { useState } from "react";

import { Price } from "@app/shared/ui";

import styles from "./PartnershipTotalCard.module.scss";

export type PartnershipTotalCardProps = {
  value?: number;
  valueType?: "value" | "percent" | "currency";
  label?: React.ReactNode;
  onClick?: () => void;
};

export const PartnershipTotalCard: React.FC<PartnershipTotalCardProps> = ({
  label,
  value,
  valueType,
  onClick,
}) => {
  const [clickable] = useState(onClick !== undefined);

  return (
    <Card
      className={cn(styles.total_card, clickable && "c-pointer hoverable")}
      onClick={onClick}
    >
      <Statistic
        title={label}
        value={value}
        // eslint-disable-next-line react/no-unstable-nested-components
        valueRender={(_) => {
          if (value === undefined) {
            return <Skeleton.Input active size="small" />;
          }

          if (valueType === "currency") {
            return <Price price={value} truncateIfFractionalZero />;
          }

          return value;
        }}
        precision={0}
        suffix={valueType === "percent" ? "%" : ""}
      />
      {clickable && (
        <div className={styles.right_icon}>
          <ArrowRightOutlined />
        </div>
      )}
    </Card>
  );
};
